import { Component, Input } from '@angular/core';
import {
  SortableSectionHeader,
  SortDirections,
} from './models/sortable-section.model';

@Component({
  template: '',
})
export class SortableSectionBaseComponent {
  readonly SortDirections = SortDirections;

  @Input() showTitle: boolean;
  @Input() sectionTitle: string;
  @Input() sectionHeaders: SortableSectionHeader[];
  @Input() disabledHeaders: SortableSectionHeader[] = [];
  @Input() selectedHeader: string;
  @Input() hasSectionData: boolean;
  @Input() noDataText: string;
  @Input() tabletHeaderButtonText?: string;
  @Input() darkHeaders = false;
  @Input() alternateDesign = false;
  @Input() showSelectAll = false;
  @Input() selectAllSelected = false;
  @Input() nothingToSelect = false;

  constructor() {}

  trackItem(index: any, item: SortableSectionHeader) {
    return item ? item?.headerName : index;
  }
}
